titles:
  welcome: Welkom bij 4YourPlan!
  instruction: We gaan samen instellen
  companyDetails:
  openingHours:
  treatments:
  customers:
fields:
  companyName: Bedrijfsnaam
  address: Adres
  phoneNumber: Telefoon
  email: E-mail
actions:
  letsStart: Nu beginnen
  doLater: Later doen
  done: Voltooien
  back: Vorige
  skip: Overslaan
  addTreatment: Nog een behandeling toevoegen
labels:
  optional: (optioneel)
  configureTenant: Salon instellen
  treatmentCount: Behandeling {index}
messages:
  onboardingInstructions: Fijn dat je aan de slag gaat! We helpen je graag om je bedrijf in te richten. Dit duurt slechts een paar minuten.
  onboardingSuggestion: Je kunt later altijd medewerkers toevoegen, meer behandelingen instellen en alle details verder aanpassen.
  companyDetailsSuggestion: Je logo, kleur en foto's voor de publieke boekingspagina kun je later instellen via de instellingen.
  openingHoursSuggestion: Deze openingstijden en pauzes worden automatisch toegepast op alle medewerkers. Je kunt later per medewerker afwijkende werktijden instellen via de instellingen.
  treatmentsSuggestion: Je kunt later meer behandelingen toevoegen en details zoals voorbereidingsinstructies en gezondheidsverklaringen instellen.
  doneSuggestion: Na voltooien kun je in de instellingen medewerkers toevoegen, meer behandelingen instellen en alle details verder aanpassen.
  importedCustomers: "{count} klant is succesvol geïmporteerd|{count} klanten zijn succesvol geïmporteerd"
  noTreatmentsOrCustomers: Je hebt nog geen behandelingen of klanten toegevoegd. Geen probleem! Je kunt dit later doen via de instellingen.
  steps:
    companyDetails:
      instructionTitle: Bedrijfsinformatie
      instructionSubtitle: Basis gegevens van je bedrijf
      title: Bedrijf
      stepperHeader: Bedrijfsinformatie
      stepperDescription: Vul de basisgegevens van je bedrijf in, deze zijn zichtbaar op de publieke pagina voor jouw klanten
      doneTitle: Bedrijfsinformatie
    openingHours:
      instructionTitle: Openingstijden
      instructionSubtitle: Wanneer is je bedrijf open voor afspraken?
      title: Tijden
      stepperHeader: Openingstijden instellen
      stepperDescription: Stel per dag in of je open bent en wat de openingstijden zijn
      doneTitle: Openingstijden
    treatments:
      instructionTitle: Je eerste behandelingen
      instructionSubtitle: Welke diensten bied je aan in je bedrijf?
      title: Behandelingen
      stepperHeader: Behandelingen toevoegen
      stepperDescription: Voeg minimaal één behandeling toe die je aanbiedt
      doneTitle: Behandelingen
    customers:
      instructionTitle: Salonized klanten importeren
      instructionSubtitle: Neem je bestaande klanten mee
      title: Import
      stepperHeader: Klanten importeren
      stepperDescription: Importeer je bestaande klanten uit Salonized
      doneTitle: Klanten geïmporteerd
    done:
      title: Klaar
      stepperHeader: Klaar!
      stepperDescription: Hier is een overzicht van wat je hebt ingesteld
